module.exports = __webpack_public_path__ + "static/media/tranquilidad_new.02348b27.jpg";